import { get, post } from './http';

const baseUrl = process.env.VUE_APP_BASE_URL;

// 获取模板列表
const getTemplate = (params) => get(`${baseUrl}/template/suit/list`, params);
// 生成ppt所有的幻灯片
const createPowerPoint = (data, signal) => post(`${baseUrl}/slide/generateAll`, data, signal);
// 导出ppt文件
const exportPowerPoint = (data) => post(`${baseUrl}/slide/export`, data, null, null, 'blob');
// 获取已生成的幻灯片
const getPowerPoint = (params) => get(`${baseUrl}/slide/list`, params);
// 保存幻灯片到我的文件
const savePowerPoint = (data) => post(`${baseUrl}/slide/saveFile`, data);
// 获取模板标签列表
const getTemplateTag = (params) => get(`${baseUrl}/template/tag/list`, params);
// 获取内容页模板列表
const getTemplateContent = (params) => get(`${baseUrl}/template/content/list`, params);
// 生成单页幻灯片
const createSinglePowerPoint = (data, signal) => post(`${baseUrl}/slide/generate`, data, signal);
// 将游客模式下生成的幻灯片同步到登录账号
const syncSlide = (data) => post(`${baseUrl}/slide/syncFromGuest`, data);
// 获取主题风格套系标签列表
const getTemplateSuitTag = (params) => get(`${baseUrl}/template/suitTag/list`, params);

export default {
  getTemplate,
  createPowerPoint,
  exportPowerPoint,
  getPowerPoint,
  savePowerPoint,
  getTemplateTag,
  getTemplateContent,
  createSinglePowerPoint,
  syncSlide,
  getTemplateSuitTag,
}
